import React from 'react';

function Icon() {
  return (
    <svg width="18" height="18" fill="none" viewBox="0 0 18 18">
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M16.79 13.32c-.884-.81-3.27-2.7-4.772-2.7h-.266l-.618-.63C11.929 9 12.37 7.65 12.37 6.3c0-1.71-.619-3.24-1.856-4.41C9.367.63 7.865 0 6.185 0c-1.678 0-3.18.63-4.33 1.8C.62 3.06 0 4.59 0 6.3s.619 3.24 1.856 4.41c1.148 1.26 2.65 1.89 4.33 1.89 1.325 0 2.65-.45 3.71-1.26l.62.63c-.178 1.53 1.502 3.78 2.65 5.13.53.54 1.237.9 1.944.9.707 0 1.326-.27 1.856-.81s.795-1.26.795-1.98c-.088-.72-.442-1.35-.972-1.89zM3.092 9.45c-.884-.81-1.326-1.98-1.326-3.15s.442-2.34 1.326-3.15c.795-.9 1.944-1.35 3.092-1.35 1.15 0 2.298.45 3.093 1.35.884.81 1.326 1.98 1.326 3.15s-.442 2.34-1.326 3.15c-.795.9-1.944 1.35-3.093 1.35-1.148 0-2.297-.45-3.092-1.35zm11.31 6.39c.354.36.884.45 1.237.09.177-.18.265-.36.177-.63 0-.27-.088-.45-.265-.63-1.59-1.44-2.74-2.07-3.358-2.25.177.63.795 1.8 2.21 3.42z"
        clipRule="evenodd"></path>
    </svg>
  );
}

export default Icon;
